import { RouteConfig } from 'vue-router';
import RecaptchaV3Test from './recaptchaV3-test.vue';

const route:RouteConfig = {
  path: 'recaptchatest',
  component: RecaptchaV3Test,
};

export function getDefaultParams() {
  return {};
}

export default route;
